<div class="grid">
  <div class="col-12">
    <div class="p-fluid">
      <div class="field">
        <p-dropdown [options]="items$ | async" [(ngModel)]="selected" [filter]="true"
          placeholder="Выберите конференцию" [autoDisplayFirst]="false" optionLabel="name" name="selectedconference">
        </p-dropdown>
      </div>
    </div>
  </div>
</div>

<p-toolbar>
  <div class="p-toolbar-group-left">
    <button [disabled]="!selected" pButton type="button" label="Сохранить" class="p-button-success"
      (click)="onSubmit()"></button>
  </div>
  <div class="p-toolbar-group-right">
    <button pButton type="button" label="Отмена" class="p-button-secondary" (click)="onCancel()"></button>
  </div>
</p-toolbar>
